<template>
  <div>
    <div class="fe-flex fe-items-center fe-justify-between">
      <div>
        <span class="fe-text-heading-xxs">Reviews & Ratings</span>
        <span class="fe-text-body-m fe-text-primary-grey-60 fe-px-xxs"
          >&#8226;</span
        >
        <span class="fe-text-body-xs fe-text-primary-grey-80"
          >({{ totalRatingCount }} Ratings
          <template v-if="totalReviewCount !== 0"
            >& {{ totalReviewCount }} Review</template
          >)
        </span>
      </div>
      <div>^</div>
    </div>

    <div class="fe-text-body-xs fe-text-primary-grey-80">
      {{ productData.productName }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "RatingTitle",
    inject: ["globalState"],
    computed: {
      totalRatingCount() {
        return this.globalState.ratingsCount || 0
      },
      totalReviewCount() {
        return this.globalState.reviewsCount || 0
      },
      productData() {
        return this.globalState.product
      },
    },
  }
</script>
